<template>
    <v-card class="basket-card">
        <v-list>
            <v-list-item>
                <v-list-item-avatar
                        size="100"
                        tile color="grey"
                >
                    <v-img :src="cardImage"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <div class="title">{{ cardNameFull }}</div>
                            <v-rating
                                    small
                                    dense
                                    readonly
                                    half-increments
                                    color="orange lighten-2"
                                    background-color="orange lighten-2"
                                    v-model="cardRatingValue"
                            ></v-rating>
                            <div class="subtitle-1 ">{{ categoryNameFull }}</div>
                            <div class="subtitle-1 ">{{ buyerNameFull }}</div>
                        </v-col>
                        <v-col cols="12" sm="4" class="pt-10">
                            <div class="subtitle-1 ">{{ $t('quantity') }}: {{ quantityValue }} ({{ quantityUnit }})</div>
                            <div class="subtitle-1 ">{{ $t('sum') }}: {{ priceValue }} {{ priceCurrency }}</div>
                            <div class="subtitle-1 ">{{ $t('lastEdit') }}: {{ updatedDate }}</div>
                        </v-col>
                        <v-col cols="12" sm="4" class="text-right hidden-xs-only">
                            <v-row>
                                <v-col cols="12">
                                    <v-tooltip top v-if="isOften">
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="teal" icon dark v-on="on">
                                                <v-icon>playlist_add_check</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Частые</span>
                                    </v-tooltip>
                                    <v-btn
                                            outlined
                                            disabled
                                            color="teal"
                                    >{{ orderStatus }}</v-btn>
                                </v-col>
                                <v-col cols="12">
                                    <div class="pt-4">
                                        <basket-card-actions
                                                :is-often="isOften"
                                                @add-to-often="addToOften"
                                                @delete-often="deleteOften"
                                                @delete-order="deleteOrder"
                                                @open-messages="openMessages"
                                        ></basket-card-actions>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>
            <v-list-item class="d-flex d-sm-none">
                <v-row>
                    <v-col class="pt-4 text-center">
                        <v-btn
                                outlined
                                disabled
                                color="teal"
                        >{{ orderStatus }}</v-btn>
                    </v-col>
                    <v-col>
                        <div class="d-flex">
                            <v-tooltip v-if="isOften">
                                <template v-slot:activator="{ on }">
                                    <v-btn color="teal" icon dark v-on="on">
                                        <v-icon :size="26">playlist_add_check</v-icon>
                                    </v-btn>
                                </template>
                                <span>Частые</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <basket-card-actions
                                    :is-often="isOften"
                                    @add-to-often="addToOften"
                                    @delete-often="deleteOften"
                                    @delete-order="deleteOrder"
                                    @open-messages="openMessages"
                            ></basket-card-actions>
                        </div>
                    </v-col>
                </v-row>
            </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
    import BasketCardActions from './BasketCardActions';

    export default {
        name: "BasketSingleCard",
        props:['cardData'],
        components:{BasketCardActions},
        data(){
            return {
                cardAction: null,
                defaultCardImage: '//cdn.agro-mp.local/images/products/default-product.png',
                rating: {
                    value: null,
                    total: null
                },
            }
        },
        computed: {
            buyerNameFull(){
                if(this.cardData.company && this.cardData.company.name) {
                    return this.cardData.company.name;
                } else if(this.cardData.buyer) {
                    return this.cardData.buyer.name + ' ' + this.cardData.buyer.soname;
                } else {
                    return '';
                }
            },
            buyerNameShort(){
                if(this.cardData.company && this.cardData.company.name) {
                    return this.cardData.company.name.split(' ')[0] + '...';
                } else if(this.cardData.buyer) {
                    return this.cardData.buyer.name + ' ' + this.cardData.buyer.soname;
                } else {
                    return '';
                }
            },
            cardImage(){
                return this.cardData.images ? this.cardData.images[0] : this.defaultCardImage;
            },
            cardNameFull(){
                return this.cardData.product ? this.cardData.product.name : '';
            },
            cardNameShort(){
                return this.cardData.product ? this.cardData.product.name.split(' ')[0] + '...' : '';
            },
            cardRatingTotal: {
                get: function(){
                    return this.cardData.rating ? this.cardData.rating.total : 0;
                },
                set: function(value){
                    this.cardData.rating.total++;
                }
            },
            cardRatingValue: {
                get: function(){
                    return this.cardData.rating ? this.cardData.rating.value : 0;
                },
                set: function(value){
                    this.cardData.rating.value = value;
                    this.$emit('rating-changed', value);
                }
            },
            categoryNameFull(){
                return this.cardData.category ? this.cardData.category.name : '';
            },
            categoryNameShort(){
                return this.cardData.category ? this.cardData.category.name.split(' ')[0] + '...' : '';
            },
            isOften(){
                return !!this.cardData.is_often;
            },
            orderStatus(){
                return this.cardData.status ? this.cardData.status.name : '';
            },
            priceCurrency() {
                return this.cardData.price ? this.cardData.price.currency.toString().toUpperCase() : '';
            },
            priceValue() {
                return this.cardData.price ? this.cardData.price.value : '';
            },
            quantityUnit() {
                return this.cardData.quantity ? this.cardData.quantity.name : '';
            },
            quantityValue() {
                return this.cardData.quantity ? this.cardData.quantity.value : '';
            },
            updatedDate(){
                return this.cardData.updated_at || '';
            }
        },
        methods: {
            addToOften() {
                this.$emit('add-to-often', this.cardData.id);
            },
            deleteOften() {
                this.$emit('delete-often', this.cardData.id);
            },
            deleteOrder(){
                this.$emit('delete-order', this.cardData.id);
            },
            openMessages(){
                this.$emit('open-messages', this.cardData.id);
            }
        }
    }
</script>

<style scoped>
    .basket-card {
        width: 100%!important;
    }
</style>
